export default "__VITE_ASSET__eHPa1RYj__"